import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { finishOAuthFlow } from "auth/actions";
import { FRONTEND_ROOT } from "config/constants";

const mapStateToProps = state => ({
  isAuthenticated: state.isAuthenticated,
});

const mapDispatchToProps = {
  finishOAuthFlow,
};

/**
 * Implements the client side of the second step in the implicit grant OAuth 2 flow
 * We get a postback from the OAuth server with our access token in the querystring and parse it into redux
 */
class AuthRedirect extends PureComponent {
  UNSAFE_componentWillMount() {
    if (window.frameElement) {
      window.parent.postMessage(
        { authRedirect: window.location.href },
        FRONTEND_ROOT
      );
    }

    this.props.finishOAuthFlow(window.location.href);
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    if (this.props.isAuthenticated) {
      return <Redirect to={from} />;
    } else {
      // When the user is first redirected from the OAuth provider,
      // isAuthenticated is false and this page should not render. After the
      // redux store gets updated, isAuthenticated is passed back down and the
      // component is re-rendered as a redirect.
      return null;
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthRedirect);
